function hexStringToArrayBuffer(hexString) {
  const bytes = new Uint8Array(hexString.length / 2)
  for (let i = 0; i < hexString.length; i += 2) {
    bytes[i / 2] = parseInt(hexString.substring(i, i + 2), 16)
  }
  return bytes.buffer
}

async function importAesCbcKey(hexKeyString) {
  const rawKeyBuffer = hexStringToArrayBuffer(hexKeyString)
  const key = await crypto.subtle.importKey(
    "raw",
    rawKeyBuffer,
    {
      name: "AES-CBC",
      length: 128,
    },
    true,
    ["encrypt", "decrypt"] // keyUsages
  )
  return key
}

export async function encryptText({
  text,
  key,
}) {
  let enc = new TextEncoder()
  let encoded = enc.encode(text)
  const iv = crypto.getRandomValues(new Uint8Array(16))
  const ivBase64 = iv.toBase64()
  const k = await importAesCbcKey(key)
  const encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, k, encoded)
  const uint8Array = new Uint8Array(encrypted)
  const encryptedBase64 = uint8Array.toBase64()
  return `${encryptedBase64}:${ivBase64}`
}

function base64ToUint8Array(base64) {
  const binaryString = atob(base64); // Decode the Base64 string to a binary string
  const length = binaryString.length;
  const bytes = new Uint8Array(length); // Create a new Uint8Array with the same length

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i); // Populate the Uint8Array with the character codes
  }
  return bytes;
}

export async function decryptText({
  encrypted,
  key,
}) {
  const split = encrypted.split(":")
  const encryptedBase64 = split[0]
  const ivBase64 = split[1]
  const k = await importAesCbcKey(key)
  const decrypted = await crypto.subtle.decrypt({ name: "AES-CBC", iv: base64ToUint8Array(ivBase64) }, k, base64ToUint8Array(encryptedBase64))
  const decryptedText = new TextDecoder().decode(decrypted)
  return decryptedText
}